import { createAction, props } from '@ngrx/store';

export const fetchInternalOrderCodes = createAction(
  '[InternalOrder] Fetch Codes'
);

export const fetchInternalOrderCodesSuccess = createAction(
  '[InternalOrder API] Fetch Codes Success',
  props<{ codesData: { [id: string]: string } }>()
);

export const fetchInternalOrderCodesFailure = createAction(
  '[InternalOrder API] Fetch Codes Failure'
);
